export const CLEVERTAP_ID =
  process.env.NODE_ENV === "production" ? "489-7K9-456Z" : "TEST-589-7K9-456Z";
